import React from 'react';
import * as styles from '../css/section-title.css';

const SectionTitle: React.FC = ({ children }) => (
    <h2 className={styles.root}>
        {children}
    </h2>
);

export default SectionTitle;
